module.exports = __webpack_public_path__ + "img/quick1.69cd2493.png";